import { Button, CircularProgress } from "@material-ui/core";
import React from "react";
import styled from "styled-components";
import { Colors, Spacing } from "../../config";
import { formConnector } from "../../FormConfig";
import FontStyles from "../styles/fontsStyles";

const StyledButton = styled(Button)(({ theme, $defaultColor, $color }) => {
  const { spacing } = theme;
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: spacing(0.5, 2),
    overflow: "hidden",
    ...FontStyles.bold14,
    color:
      $defaultColor || $color === 2
        ? Colors.red
        : $color === 1
        ? Colors.orange
        : Colors.red,
    textTransform: "uppercase",
  };
});

const StyledCircularProgress = styled(CircularProgress)(({ theme, $show }) => {
  const { palette: colors } = theme;
  return {
    position: "absolute",
    color: colors.primary.main,
    transition: ".5s",
    opacity: $show ? 1 : 0,
  };
});

const ChildrenContainer = styled.div(({ $show }) => {
  return {
    transition: ".5s",
    opacity: $show ? 1 : 0.5,
  };
});

function ButtonTextComponent({
  fullWidth = true,
  loading,
  children,
  type,
  disabled,
  name,
  defaultColor,
  color,
  ...props
}) {
  const {
    disabled: stateDisabled,
    onClick,
    ref,
  } = formConnector.useFormButton({
    type,
    disabled,
    name,
    defaultColor,
  });
  return (
    <StyledButton
      variant="text"
      ref={ref}
      type={null}
      fullWidth={fullWidth}
      disabled={stateDisabled}
      $defaultColor={defaultColor}
      onClick={onClick}
      $color={color}
      {...props}
    >
      <StyledCircularProgress size={Spacing(3)} $show={loading} />
      <ChildrenContainer $show={!loading}>{children}</ChildrenContainer>
    </StyledButton>
  );
}

export default ButtonTextComponent;
